{
	"title": "Что повторить сегодня",
	"subtitle": "Адаптивные рекомендации",
	"refresh": "Обновить",
	"preliminary": "Уточняется…",
	"updatedAt": "Обновлено {time}",
	"staleHint": "Обновлено {hours, plural, one {# час} few {# часа} many {# часов} other {# часов}} назад",
	"showMore": "Показать ещё",
	"showAll": "Все рекомендации",
	"empty": {
		"title": "Всё в порядке — ничего срочного",
		"body": "Загляни завтра или попробуй новую тему",
		"newTopic": "Новая тема",
		"templates": "Шаблоны планов"
	},
	"action": {
		"study": "Изучать",
		"take": "Пройти",
		"continue": "Продолжить",
		"open": "Открыть",
		"studyNow": "Изучать сейчас",
		"dismiss": "Скрыть"
	},
	"reason": {
		"srs-due": "Срочно — пора повторить",
		"weak-spot": "Слабая тема",
		"new-material": "Новый материал",
		"streak-at-risk": "Стрик под угрозой",
		"study-plan-next": "Следующая тема плана",
		"forgotten-topic": "Забытая тема",
		"exam-soon": "Скоро экзамен"
	},
	"priority": "Приоритет",
	"error": {
		"title": "Не удалось загрузить рекомендации",
		"retry": "Повторить"
	}
}
